import { FrontendPageContent } from "@/components/frontend/FrontendPageContent";
import { HOME_ORG_PATH } from "@/config/constants";
import { useBreadcrumb } from "@/contexts/shared/breadcrumb";
import { useDocumentTitle } from "@/hooks/useDocumentTitle";
import { useMountEffect } from "@react-hookz/web";
import { ClauseChecklistsList } from "./components/clause-checklists/ClauseChecklistsList";

/**
 * The organization checklists page
 */
const OrganizationClauseChecklists = () => {
    const { setBreadcrumbs } = useBreadcrumb();

    useDocumentTitle("Checklists");

    useMountEffect(() => {
        setBreadcrumbs([
            { label: "Home", path: HOME_ORG_PATH },
            { label: "Checklists" },
        ]);
    });

    return (
        <FrontendPageContent className="overflow-y-auto p-4">
            <ClauseChecklistsList />
        </FrontendPageContent>
    );
};

export default OrganizationClauseChecklists;
